import type { Network, SelectedNetwork } from '@/types';
import { PrefixedSelect, SelectOption } from '../PrefixedSelect';

type NetworksFilterProps = {
  networks: Network[];
  selectedNetwork: SelectedNetwork;
  onApply: (networkId: string) => void;
  onOpen?: () => void;
};

const NetworksFilter = ({
  networks = [],
  selectedNetwork,
  onApply,
  onOpen,
}: NetworksFilterProps) => {
  const handleApply = (networkId: string) => {
    onApply(networkId);
  };

  const handleOpen = () => {
    onOpen?.();
  };

  const displayLabel = selectedNetwork?.name ? `Network: ${selectedNetwork.name}` : 'Select a network';

  return (
    <PrefixedSelect
      data-testid="network-select"
      displayLabel={displayLabel}
      placeholder="Network"
      value={selectedNetwork?.id ?? ''}
      onClick={handleOpen}
      onChange={(event) => {
        const selectedValue = (event.target as HTMLSelectElement).value;
        handleApply(selectedValue);
      }}
    >
      {networks?.length > 0 &&
        networks.map((network) => (
          <SelectOption key={network.id} value={network.id}>
            {network.name}
          </SelectOption>
        ))}
    </PrefixedSelect>
  );
};

export default NetworksFilter;
